<template>
    <div class="treasure">
        <!-- 宝箱ICON -->
        <div class="treasure_iconbtn" @click="clickTreasureIcon()">
            <div v-if="second != 0" class="treasure_time">{{ getIntervalTime(second) }}</div>
        </div>

        <!-- 宝箱弹窗 -->
        <div v-show="treasurePopFalg" class="dialog">
            <div v-show="treasureGifFalg" class="treasure_open">
                <img src="../../assets/lives/bx_gif.gif" alt="">
                <button>开宝箱</button>
            </div>

            <div v-show="treasureLabelFalg" class="treasure_label">
                <div v-show="currentSetp == 1 || currentSetp == 2" class="integralLabel">
                    <span class="treasure_title">开宝箱</span>
                    <span class="treasure_tip">本次活动您已累计获得<span style="color: #AA7565;">{{ userPointsTotal }}积分</span></span>
                    <div style="width: 100%; text-align: left">
                        <span style="display: block; color: #777777; margin-bottom: 8px;">活动规则：</span>
                        <span id="treasureRules" style="word-break: break-word; display: block">{{ treasureBoxDate.rules
                        }}</span>
                    </div>

                    <img v-show="currentSetp == 1 || (currentSetp == 2 && second != 0 && !treasureBoxDate.isEnd)"
                        class="lineimg" src="../../assets/lives/bx_line.png" alt="">

                    <div v-show="currentSetp == 1">
                        <span class="getIntegral"><span id="singleIntegral" style="font-size: 20px;">{{
                            treasureBoxDate.pointsNum }}</span>积分</span>
                        <div class="gettimeout getIntegral">
                            <span class="linetime"></span>
                            <span style="font-weight: 500; margin: 0 12px; ">倒计时：<span>{{ getIntervalTime(second)
                            }}</span></span>
                            <span class="linetime"></span>
                        </div>
                        <button id="getIntegral" class="getIntegral getbtn" @click="getIntegral()">立即领取</button>
                    </div>

                    <span v-show="currentSetp == 2 && second != 0 && !treasureBoxDate.isEnd">下一批宝箱正在赶来...</span>

                    <button v-show="currentSetp == 2 && second == 0 && userPointsTotal >= treasureBoxDate.goalNum"
                        id="exchange" class="getbtn" @click="exchange()" style="margin-top: 60px;">去兑换</button>
                </div>

                <div v-show="currentSetp == 3" class="exchangeFormBox">
                    <div v-show="treasureExchangeType.cashType == 1" id="submitForm" class="exchangeForm">
                        <span class="treasure_title">兑奖</span>
                        <span class="treasure_tip">提交表单后，我们会及时与您联系</span>
                        <input v-model="exchangeForm.name" type="text" placeholder="姓名" class="formInput" maxlength="10" />
                        <input v-model="exchangeForm.phone" type="text" placeholder="手机号" class="formInput" />
                        <button class="getbtn" @click="submitExchange()" style="margin-top: 36px;">提交</button>
                    </div>

                    <div v-show="treasureExchangeType.cashType == 2" id="submitUrl" class="exchangeForm">
                        <span class="treasure_title">兑奖</span>
                        <span class="treasure_tip">扫码提交后，我们会及时与您联系</span>
                        <div style="width: 70%; padding-bottom: 70%;position: relative; ">
                            <div class="exchangeqrcode"
                                :style="{ backgroundImage: `url(${treasureExchangeType.qrcodeUrl})` }">
                            </div>
                        </div>
                    </div>
                </div>

                <img @click="treasurePopFalg = false" src="../../assets/lives/guan_ds.png" alt=""
                    class="treasure_closebtn" />
            </div>
        </div>
    </div>
</template>

<script>
import { preTime } from "@/utils/util"
var treasureInterval //抽奖倒计时

export default {
    name: "treasureBox",
    props: ['treasureBoxDates', 'isEndTreasure'],
    data() {
        const CURRENTSETP = {
            1: '领取积分前',
            2: '领取积分后',
            3: "兑奖"
        }
        return {
            treasureBoxDate: {
                "id": 1375,
                "boxId": 276,
                "detailName": "宝箱一",
                "boxOrder": 1,
                "pointsNum": 2,
                "joinNum": 0,
                "fillNum": 0,
                "state": 3,
                "openUserName": "2222",
                "openTime": 1699171660336,
                "rules": "33",
                "timer": 0,
                "goalNum": 3,
                "isEnd": false
            },
            treasureExchangeType: {
                "boxId": 278,
                "title": "3333",
                "rules": "2222",
                "boxNum": 3,
                "pointsType": 1,
                "pointsNum": 1,
                "goalNum": 2,
                "timer": 60,
                "cashType": 1,
                "state": 2,
                "createTime": 1699252902000,
                "roomId": 22136573
            },   //宝箱兑奖方式
            second: 0,
            userPointsTotal: 3,      //用户总积分
            treasurePopFalg: false, //宝箱弹窗
            treasureGifFalg: false, //宝箱动图
            treasureLabelFalg: false,
            currentSetp: 1,
            exchangeForm: {         //表单兑奖
                name: '',
                phone: "",
            },
            antiShake: [],     //防抖
        }
    },

    watch: {
        isEndTreasure: function (news, olds) {
            if (news) {
                clearInterval(treasureInterval)
                this.second = 0
                this.treasurePopFalg = false
            }
        },
        treasureBoxDate: function (news, olds) {
            if (news) {
                this.initTreasure()
            }
        }
    },

    mounted() {
        this.initTreasure()
    },

    methods: {
        // 宝箱初始化
        initTreasure() {
            clearInterval(treasureInterval)
            var that = this
            if (that.treasureBoxDate.timer > 0) {
                that.second = that.treasureBoxDate.timer
                treasureInterval = setInterval(() => {
                    that.second--
                    if (that.second <= 0) {
                        clearInterval(treasureInterval)
                        that.treasurePopFalg = false
                        that.currentSetp = 2
                        that.second = 0
                    }
                }, 1000)
            }
            that.getServiceUserPoints()
            if (!localStorage.getItem("treasurePoints" + this.treasureBoxDate.id)) {
                that.currentSetp = 1
                that.treasureGifFalg = true
                that.treasurePopFalg = true
                setTimeout(() => {
                    that.treasureGifFalg = false
                    that.treasureLabelFalg = true
                }, 1500)
            } else {
                this.currentSetp = 2
            }
        },

        // 获取用户当前积分
        getServiceUserPoints() {
            let param = {
                account: localStorage.getItem('user_account'),
                roomId: localStorage.getItem('room_id'),
                boxId: this.treasureBoxDate.boxId,
            }
            this.$api.checkUserPoints(param).then(res => {
                if (res.data.code == 200) {
                    this.userPointsTotal = res.data.data.points
                }
            })
        },

        // 点击宝箱ICON
        clickTreasureIcon() {
            this.treasurePopFalg = true
            this.treasureLabelFalg = true
        },

        // 领取积分
        getIntegral(type) {
            if (this.antiShake.indexOf(type) != -1) {
                this.$message.error("请不要重复点击")
                return;
            }
            this.antiShake.push(type)
            let param = {
                boxId: this.treasureBoxDate.boxId,
                detailId: this.treasureBoxDate.id,
                pointsNum: this.treasureBoxDate.pointsNum,
                account: localStorage.getItem('user_account'),
                roomId: localStorage.getItem('room_id'),
                nickname: localStorage.getItem('user_name'),
                channelName: sessionStorage.getItem('channel_info') ? sessionStorage.getItem('channel_info').title : "",
                channelId: sessionStorage.getItem('channel_info') ? sessionStorage.getItem('channel_info').channel_id : "",
            }

            this.$api.submitBoxList(param).then(res => {
                this.antiShake.splice(this.antiShake.indexOf(type), 1)
                if (res.data.code == 200) {
                    this.currentSetp = 2
                    this.$message.success('领取成功')
                    this.userPointsTotal += this.treasureBoxDate.pointsNum
                    localStorage.setItem("treasurePoints" + this.treasureBoxDate.id, true)
                }
            }).catch(err => {
                this.antiShake.splice(this.antiShake.indexOf(type), 1)
            })
        },

        // 点击兑换
        exchange(type) {
            var that = this
            if (that.antiShake.indexOf(type) != -1) {
                that.$message.error("请不要重复点击")
                return;
            }
            that.antiShake.push(type)
            that.currentSetp = 3
            let exchangeBefore = {
                account: localStorage.getItem('user_account'),
                roomId: localStorage.getItem('room_id'),
                boxId: that.treasureBoxDate.boxId,
            }
            that.$api.checkUserPoints(exchangeBefore).then(res => {
                if (res.data.code == 200) {
                    that.userPointsTotal = res.data.points
                    that.treasureExchangeType = res.data.data
                    if (res.data.points >= that.treasureBoxDate.goalNum) {
                        that.$api.getBoxCash(that.treasureBoxDate.boxId).then(res => {
                            that.antiShake.splice(that.antiShake.indexOf(type), 1)
                            if (res.data.code == 200) {
                                if (res.data.cashType == 3) {
                                    window.location.href = res.data.connectUrl
                                }
                            }
                        }).catch(err => {
                            that.antiShake.splice(that.antiShake.indexOf(type), 1)
                        })
                    }
                }
            }).catch(err => {
                that.antiShake.splice(that.antiShake.indexOf(type), 1)
            })
        },

        // 表单兑奖提交
        submitExchange(type) {
            if (!this.exchangeForm.name) {
                this.$message.error('姓名不能为空')
                return;
            } else if (!/^1[3-9]\d{9}$/.test(this.exchangeForm.phone)) {
                this.$message.error("请输入正确的手机号码")
                return;
            }
            if (this.antiShake.indexOf(type) != -1) {
                this.$message.error("请不要重复点击")
                return;
            }
            this.antiShake.push(type)
            let param = {
                boxId: this.treasureBoxDate.boxId,
                name: this.exchangeForm.name,
                mobile: this.exchangeForm.phone,
                account: localStorage.getItem('user_account'),
                roomId: localStorage.getItem('room_id'),
                nickname: localStorage.getItem('user_name'),
                channel: sessionStorage.getItem('channel_info') ? sessionStorage.getItem('channel_info').title : "",
                channelId: sessionStorage.getItem('channel_info') ? sessionStorage.getItem('channel_info').channel_id : "",
            }
            this.$api.submitBoxForm(param).then(res => {
                if (res.data.code == 200) {
                    this.antiShake.splice(this.antiShake.indexOf(type), 1)
                    this.$message.success('提交成功')
                    this.treasurePopFalg = false
                } else {
                    this.antiShake.splice(this.antiShake.indexOf(type), 1)
                }
            }).catch(err => {
                this.antiShake.splice(this.antiShake.indexOf(type), 1)
            })
        },

        getIntervalTime(time) {
            return preTime(time)
        },
    },
}
</script>

<style lang="scss" scoped>
.treasure {
    position: absolute;
    top: 10px;

    &_iconbtn {
        width: 38px;
        height: 38px;
        text-align: center;
        margin-left: 10px;
        position: relative;
        background: url('../../assets/lives/bx_btn.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    &_time {
        display: block;
        position: absolute;
        bottom: -10px;
        left: -10px;
        background: rgba(0, 0, 0, 0.4);
        font-size: 20px;
        color: #fff;
        padding: 0 3px;
        text-align: center;
        transform: scale(0.5);
        border-radius: 5px;
    }

    &_open {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 15%;
        transform: translate(0, -30%);

        &>img {
            width: 18%;
        }

        &>button {
            width: 12%;
            border: none;
            color: #751c00;
            line-height: 45px;
            font-size: 16px;
            font-weight: bold;
            background: linear-gradient(225deg, #FFE999 12%, #FFDC61 44%, #F5870A 87%);
            border-radius: 5px;
        }
    }

    &_title {
        font-size: 20px;
        color: #621E04;
        line-height: 23px;
        margin-bottom: 6px;
    }

    &_tip {
        margin-bottom: 16px;
        color: #777777;
    }

    &_label {
        background: url('../../assets/lives/bx_bg.png') no-repeat;
        width: 17%;
        min-width: 290px;
        min-height: 270px;
        margin: 10% auto 0 auto;
        background-color: #fff;
        border-radius: 15px;
        font-size: 13px;
        background-size: 100% 50%;
        padding: 20px;
        box-sizing: border-box;
        letter-spacing: 1px;
        position: relative;
    }

    &_closebtn {
        width: 32px;
        height: 32px;
        position: absolute;
        bottom: -65px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .integralLabel {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .linetime {
        display: inline-block;
        height: 2px;
        width: 63px;
        background: #CECECE;
    }

    .getbtn {
        border: none;
        color: #fff;
        background: #ff6258;
        width: 100%;
        line-height: 48px;
        border-radius: 24px;
    }

    .gettimeout {
        align-items: center;
        margin: 16px 0 26px 0;
        display: flex;
    }

    .lineimg {
        width: 40px;
        height: 40px;
        margin: 36px 0 18px 0;
    }

    .exchangeForm {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .formInput {
        border: 1px solid #CECECE;
        line-height: 40px;
        border-radius: 20px;
        background: rgba(0, 0, 0, 0);
        width: 100%;
        text-align: center;
        font-size: 13px;
        margin: 10px 0;
    }

    .exchangeqrcode {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }
}
</style>